export default __webpack_public_path__ + "static/media/involve.5618dbe0.svg";